var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 0.750244C5.25 0.336031 5.58579 0.000245098 6 0.000245103C6.38463 0.000245108 6.70163 0.289774 6.74495 0.662779L6.75 0.750244L6.75 11.2502C6.75 11.6645 6.41421 12.0002 6 12.0002C5.61537 12.0002 5.29837 11.7107 5.25505 11.3377L5.25 11.2502L5.25 0.750244Z",
    fill: "#E50B20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.21967 6.53057C-0.0732233 6.23768 -0.0732232 5.76281 0.21967 5.46991C0.490033 5.19955 0.915456 5.17875 1.20967 5.40752L1.28033 5.46991L6 10.189L10.7197 5.46991C10.99 5.19955 11.4155 5.17875 11.7097 5.40752L11.7803 5.46991C12.0507 5.74028 12.0715 6.1657 11.8427 6.45992L11.7803 6.53057L6.53033 11.7806C6.25997 12.0509 5.83454 12.0717 5.54033 11.843L5.46967 11.7806L0.21967 6.53057Z",
    fill: "#E50B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerDownArrow);
export default __webpack_public_path__ + "static/media/danger-down-arrow.0c6b2a246ee9b61c583a1cc3a871fa71.svg";
export { ForwardRef as ReactComponent };